import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@pg-env/environment';

@Injectable({
  providedIn: 'root'
})
export class ManageUltimateRemittersService {
  api: string;

  constructor(private http: HttpClient) {
    this.api = environment.customerApiUrl + `/ultimateRemitter`;
  }

  // Get ultimate remitters of a particular account
  public getUltimateRemitters(params): Observable<any> {
    return this.http.post(`${this.api}/get-ultimate-remitters`, params, { observe: 'response' });
  }

  public insertUltimateRemitter(param): Observable<any> {
    return this.http.post(`${this.api}/insert-ultimate-remitter`, param);
  }

  public updateUltimateRemitter(param): Observable<any> {
    return this.http.post(`${this.api}/update-ultimate-remitter`, param);
  }

  public deleteUltimateRemitter(param): Observable<any> {
    return this.http.post(`${this.api}/delete-ultimate-remitter`, param);
  }
}
